<template>
    <div class="comment-parent-row-wrapper">
        <div v-if="(commentData.status && commentData.status.toLowerCase() != 'deleted') && isReplyEditDeleteActionRequired" class="actions-on-parent-comment">
            <svg v-if="isRepliedActionRequired" v-on:click.stop.prevent="openRepliesOrAddReply(false)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-reply-fill" viewBox="0 0 16 16">
                <path d="M5.921 11.9 1.353 8.62a.719.719 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"/>
                <title>Reply</title>
            </svg>
            <svg v-if="(commentData.user_id == getLoggedInUserId) || (isAnnotationCommentType(commentData) && commentData.created_by_id == getLoggedInUserId && isEnabled('manage-asset-annotaion'))" v-on:click.stop.prevent="editParentComment(commentData)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen-fill" viewBox="0 0 16 16">
                <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                <title>Edit</title>
            </svg>
            <svg v-if="commentData.user_id == getLoggedInUserId || (isAnnotationCommentType(commentData) && commentData.created_by_id == getLoggedInUserId && isEnabled('manage-asset-annotaion'))" v-on:click.stop.prevent="deleteSelectedMessage(commentData)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                <title>Delete</title>
            </svg>
        </div>
        <div class="comments-thread-wrapper" v-click-outside="closeOpenedMentionsDopdown" >
            <div class="commentedBy-image">
                <template v-if="!isAnnotationCommentType(commentData)">
                    <template v-if="Object.keys(commentData).includes('profile_image') && !['undefined',undefined,null].includes(commentData.profile_image) && commentData.profile_image">
                        <div v-for="(value, key) in commentData.profile_image" :key="key"> 
                            <div v-if="!['undefined',undefined,null].includes(value)"> 
                                <div class='user-name-or-image user-name'  style="float:inline-start;display:inline-block;">
                                    <img :src="getProxyConvertedURL(commentData.profile_image[key])" @error="replaceWithUserIcon($event,commentData.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                </div> 
                            </div>  
                            <div v-else class="user-name-or-image user-name" :style="style(commentData.username)" :title="commentData.username" style="top:1px !important">{{ commentData.username.split("")[0] }}</div>  
                        </div>       
                    </template>
                   <div v-else class="col-1 user-name-or-image user-name" :style="style(commentData.username)" style="width:40px;margin-inline-start: 7px;margin-top: 5px;padding: 0px !important">{{ commentData.username.split("")[0] }}</div>
                </template>
                <template v-if="isAnnotationCommentType(commentData)">
                     <div v-if="commentData && commentData.profile_image"> 
                            <div class='user-name-or-image user-name'  style="float:inline-start;display:inline-block;">
                                <img :src="getProxyConvertedURL(commentData.profile_image)" @error="replaceWithUserIcon($event,commentData.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                            </div> 
                      </div>  
                      <div v-else class="col-1 user-name-or-image user-name" :style="style(commentData.username)" style="width:40px;margin-inline-start: 7px;margin-top: 5px;padding: 0px !important">{{ commentData.username.split("")[0] }}</div>
                </template>
            </div>
            <div class="comment-info-wrapper">
                <div class="comment-info-sub-wrapper">
                    <div class="commentBy-name">
                        <div style="display:flex;align-items: center;">{{commentData.username}} <span class="commentedOn-datetime">{{formatedDate(commentData.created_datetime)}}</span> <span v-if="isEnabled('Manage Version') && commentData.version_number" class="commentedOn-datetime version-tags">V-{{commentData.version_number}}</span></div>           
                    </div>
                    <template v-if="commentData.status && commentData.status.toLowerCase() != 'deleted'">
                        <div style="display: flex;justify-content: space-between;align-items: center;">
                            <div :style="!editParentCommentID || editParentCommentID != commentData._id?'flex-direction: row;':'flex-direction: column;width:100%'" style="display: flex;">
                                <div v-if="!editParentCommentID || editParentCommentID != commentData._id">
                                    <div v-if="commentData && commentData.markers && commentData.markers.mark_in != null && commentData.markers.mark_in > -1" class="commentedOn-duration">{{getDuration(commentData.markers.mark_in)}}{{getMarkoutDuration(commentData.markers)}}</div>
                                    <div class="comment-text" v-html="urlifyFromUtils(commentData.comment)"></div>
                                    <i v-if="(commentData.edited == true) ||(isAnnotationCommentType(commentData) && String(commentData.status).toLowerCase() == 'edited')" style="color: #8b8b8b;display: flex;justify-content: flex-start;position: relative;bottom: 5px;inset-inline-end :2px;">edited</i>
                                </div>
                                <chatTextArea 
                                    v-else-if="editParentCommentID && editParentCommentID == commentData._id"
                                    :editMessageEnabled='true' 
                                    :commentDataToEdit="commentData"
                                    @editMessageText="editCommentTextOfParent"
                                    :replyContext='false'
                                    :usersList="getUsersListToMention(reviewInfo)"
                                    :closeMentions="closeMentions"
                                    :uploadPathObj="uploadPathObj"
                                    @cancelEditMessageText="unsetEditFields()"
                                    :customStylesTextarea="{'disabledActions':['attach-tasks'],'unsetTextareaMAXHeight':true}"></chatTextArea>
                            </div>
                            <div style="text-align:center;padding:0px !important">
                                <svg v-if="commentData.status == 'Open'" @click.prevent.stop="updateCommentStatus()" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#e8912d" class="bi bi-clock-fill" viewBox="0 0 16 16">
                                    <title>Open</title>
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                                </svg>
                                <svg v-if="commentData.status == 'Close'" @click.prevent.stop="updateCommentStatus()" xmlns="http://www.w3.org/2000/svg" width="16" height="16"  fill="green" class="bi bi-check-circle-fill mt-1" viewBox="0 0 16 16">
                                    <title>Close</title>
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                                </svg>   
                            </div>
                        </div>
                        <div class='attachments-in-message'>
                                <div v-if="isMarkerOrAnnotation(commentData)" v-on:dblclick.stop="openPictureInPicture(commentData)" class="thumbnail-view" style="display: flex;width: 250px;justify-content: center">
                                    <img draggable="false" :src="getThumbnail(commentData)"  @error="replaceByDefaultImage" style="border-radius: 5px;width:100%"/> 
                                    <div v-if="commentData.state && commentData.state == 'OUTDATED'" class="outdated-text">
                                        OUTDATED
                                    </div>
                                    <div class="storage-type-icons-wrapper">
                                        <svg @click.stop="openPictureInPicture(commentData,$event)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                            <path d="M0 0h24v24H0V0z" fill="none"/>
                                            <title>Preview</title>
                                            <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                                        </svg>
                                        <svg v-if="commentData.state && commentData.state == 'OUTDATED' && getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(commentData)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                                        <title>View versions</title>
                                        <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                        </svg>
                                    </div>
                                </div> 
                                <template v-if="commentData.attachments_info && commentData.attachments_info.length>0">
                                    <template v-for="attachment in commentData.attachments_info">
                                        <div v-if="attachment && Object.keys(attachment).length" :key="attachment._id" :title="attachment.slug_name" v-on:dblclick="openPictureInPicture(attachment)" style="display: block;width:200px;">
                                            <div v-if="(attachment.proxy_info && attachment.proxy_info.thumbnail_uri != undefined && attachment.proxy_info.thumbnail_uri.length) || (attachment.markers && attachment.markers.frame_thumbnail_uri != undefined && attachment.markers.frame_thumbnail_uri.length)" class="thumbnail-view" style="display: flex;width: 200px;justify-content: center">
                                                <img draggable="false" :src="getThumbnail(attachment)"  @error="replaceByDefaultImage" style="border-radius: 5px;width:100%"/> 
                                                <div v-if="attachment.state && attachment.state == 'OUTDATED'" class="outdated-text">
                                                    OUTDATED
                                                </div>
                                                <div class="storage-type-icons-wrapper">
                                                    <svg @click="openPictureInPicture(attachment,$event)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                                        <path d="M0 0h24v24H0V0z" fill="none"/>
                                                        <title>Preview</title>
                                                        <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                                                    </svg>
                                                    <svg v-if="isActionEnable('Download')" @click.stop.prevent="handleDownloadAction(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                                        <title>Download</title>
                                                        <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                        <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                                    </svg>
                                                    <svg v-if="attachment.state && attachment.state == 'OUTDATED' && getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                                                        <title>View versions</title>
                                                        <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div
                                                v-else
                                                class="svg-icons-display-wrapper"
                                                style="height: 225px;display: flex;width: 100%;justify-content: center"
                                                >
                                            <div v-if="attachment.state && attachment.state == 'OUTDATED'" class="outdated-text">
                                                OUTDATED
                                            </div>
                                            <div class="svg-icons-display" style="width:90px !important;height:90px !important" v-html="getSvgIconsOfMediaTypes(attachment)"></div>
                                            <div class="storage-type-icons-wrapper">
                                                <svg v-if="isActionEnable('Download')" @click.stop.prevent="handleDownloadAction(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                                    <title>Download</title>
                                                    <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                    <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                                </svg>
                                                <svg v-if="attachment.state && attachment.state == 'OUTDATED' && getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                                                    <title>View versions</title>
                                                    <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                                </svg>
                                            </div>
                                            </div>
                                            <div v-if="'slug_name' in attachment" style="display:flex;" :title="attachment.slug_name">
                                                <div class="svg-icons-display" v-html="getSvgIconsOfMediaTypes(attachment)">
                                                </div>
                                                <div style=" margin-top: 7px; text-align: start;white-space: nowrap;width: 100%;overflow: hidden;text-overflow: ellipsis;font-size:12px;margin:9px;margin-inline-start:0px">
                                                    {{attachment.slug_name}}
                                                </div>
                                            </div> 
                                            <div v-else style="display:flex;" :title="attachment.file_name">
                                                <div class="svg-icons-display" v-html="getSvgIconsOfMediaTypes(attachment)">                              
                                                </div>
                                                <div style=" margin-top: 7px; text-align: start;white-space: nowrap;width: 100%;overflow: hidden;text-overflow: ellipsis;font-size:12px;margin:9px;margin-inline-start:0px">
                                                    {{attachment.file_name}}
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                        </div>
                    </template>
                    <template v-if="commentData.status && commentData.status.toLowerCase() == 'deleted'">
                        <i style="color: #8b8b8b;">This comment was deleted</i>
                    </template>
                    <div v-if="!selectedCommentRowID || selectedCommentRowID != commentData._id" class="replies-info-wrapper">
                        <div class="repliedBy-images">
                            <div v-if="Object.keys(commentData).includes('replied_profile_images') && !['undefined', undefined,null].includes(commentData.replied_profile_images) && commentData.replied_profile_images" style="display:inline-flex;float:inline-start">
                                <template  v-for="(userImgObj, index) in commentData.replied_profile_images">
                                    <div v-for="(value, key) in userImgObj" :key="key"> 
                                        <div v-if="!['undefined',undefined,null].includes(value)"> 
                                            <div class='user-name-or-image user-name' style="float:inline-start;display:inline-block;">
                                                <img :src="getProxyConvertedURL(value)" @error="replaceWithUserIcon($event,commentData.replied_user_names[index])" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                            </div> 
                                        </div>  
                                        <div v-else class="user-name-or-image user-name" :key="index" :style="style(commentData.replied_user_names[index])" :title="commentData.replied_user_names[index]" style="float:inline-start;">{{ commentData.replied_user_names[index].split("")[0] }}</div> 
                                    </div>    
                                </template>
                            </div>
                            <div v-else v-for="user in commentData.replied_user_names" :key="user" class="user-name-or-image user-name" :style="style(user)" :title="user" style="float:inline-start;">{{ user.split("")[0] }}</div>
                        </div>
                        
                        <div @click.stop.prevent="openRepliesOrAddReply(true)" class="repliesBy-count" :style="getReplyCount(commentData.reply_count)!= 0?'display:block':'display:none'">{{getReplyCount(commentData.reply_count)}}</div>
                    </div>
                    <div v-else-if="selectedCommentRowID == commentData._id" class="comments-thread-wrapper replied-comments-thread-wrapper">
                        <template v-for="replies in repliedCommentslist">
                            <div v-if="replies.pid == selectedCommentRowID" :ref="replies._id" :key="replies._id" style="display:flex;margin-top: 5px;" class="hover-to-show-actions">
                                <div class="commentedBy-image">
                                    <div v-if="Object.keys(replies).includes('profile_image') && replies.profile_image">
                                        <div v-for="(value, key) in replies.profile_image" :key="key"> 
                                            <div v-if="value" class='user-name-or-image user-name' style="float:inline-start;display:inline-block;">
                                                <img :src="getProxyConvertedURL(replies.profile_image[key])" @error="replaceWithUserIcon($event,replies.username)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                            </div> 
                                            <div v-else class="user-name-or-image user-name" :style="style(replies.username)" :title="replies.username" style="top:1px !important">{{ replies.username.split("")[0] }}</div>  
                                        </div>       
                                    </div>
                                    <div v-else class="col-1 user-name-or-image user-name" :style="style(replies.username)" style="width:40px;margin-inline-start: 7px;margin-top: 5px;padding: 0px !important">{{ replies.username.split("")[0] }}</div>
                                </div>
                                <div class="comment-info-wrapper replied-comment-info-wrapper">
                                    <div v-if="replies.status != 'Deleted'" class="actions-on-comment">
                                        <svg v-if="replies.user_id == getLoggedInUserId" v-on:click.stop.prevent="selectedReplyInfo = replies" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen-fill" viewBox="0 0 16 16">
                                            <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001z"/>
                                            <title>Edit</title>
                                        </svg>
                                        <svg v-if="replies.user_id == getLoggedInUserId" v-on:click.stop.prevent="deleteSelectedMessage(replies)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                                            <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                                            <title>Delete</title>
                                        </svg>
                                    </div>
                                    <div class="comment-info-sub-wrapper">
                                        <div class="commentBy-name">
                                            <div style="display:flex;align-items: center;">{{replies.username}} <span class="commentedOn-datetime">{{formatedDate(replies.created_datetime)}}</span><span v-if="isEnabled('Manage Version') && replies.version_number" class="commentedOn-datetime version-tags">V-{{replies.version_number}}</span></div>           
                                        </div>
                                        <template v-if="replies.status == 'Deleted'">
                                            <i style="color: #8b8b8b;">This comment was deleted</i>
                                        </template>
                                        <template v-if="replies.status != 'Deleted'">
                                            <div v-if="!selectedReplyInfo || selectedReplyInfo._id != replies._id">
                                                <div class="comment-text" v-html="urlifyFromUtils(replies.comment)"></div>
                                                <i v-if="replies.edited == true" style="color: #8b8b8b;display: flex;justify-content: flex-start;position: relative;bottom: 5px;inset-inline-end :2px;">edited</i>
                                            </div>
                                            <chatTextArea 
                                                v-else-if="selectedReplyInfo && selectedReplyInfo._id == replies._id"
                                                :editMessageEnabled='true' 
                                                :commentDataToEdit="replies"
                                                :replyContext="false"
                                                :usersList="getUsersListToMention(reviewInfo)"
                                                :closeMentions="closeMentions"
                                                :uploadPathObj="uploadPathObj"
                                                @editMessageText="emitEdittedCommentTextOfReply"
                                                @cancelEditMessageText="selectedReplyInfo = null"
                                                :customStylesTextarea="{'disabledActions':['attach-tasks'],'unsetTextareaMAXHeight':true}"></chatTextArea>
                                        </template>
                                    </div> 
                                    <template v-if="replies.attachments_info && replies.status != 'Deleted'" class='attachments-in-message'>
                                        <template v-for="attachment in replies.attachments_info">
                                            <div v-if="attachment && Object.keys(attachment).length" :key="attachment._id" :title="attachment.slug_name" v-on:dblclick="openPictureInPicture(attachment,$event)" style="display: block;width:200px;">
                                                <div v-if="(attachment.proxy_info && attachment.proxy_info.thumbnail_uri != undefined && attachment.proxy_info.thumbnail_uri.length) || (attachment.markers && attachment.markers.frame_thumbnail_uri != undefined && attachment.markers.frame_thumbnail_uri.length)" class="thumbnail-view" style="display: flex;width: 200px;justify-content: center">
                                                    <img draggable="false" :src="getThumbnail(attachment)"  @error="replaceByDefaultImage" style="border-radius: 5px;width:100%"/> 
                                                    <div v-if="attachment.state && attachment.state == 'OUTDATED'" class="outdated-text">
                                                        OUTDATED
                                                    </div>
                                                    <div class="storage-type-icons-wrapper">
                                                        <svg @click="openPictureInPicture(attachment,$event)" xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 22 22" width="16" fill="#a3adad">
                                                            <path d="M0 0h24v24H0V0z" fill="none"/>
                                                            <title>Preview</title>
                                                            <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"/>
                                                        </svg>
                                                        <svg v-if="isActionEnable('Download')" @click.stop.prevent="handleDownloadAction(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                                            <title>Download</title>
                                                            <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                            <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                                        </svg>
                                                        <svg v-if="attachment.state && attachment.state == 'OUTDATED' && getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                                                            <title>View versions</title>
                                                            <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                                        </svg>
                                                    </div>
                                                </div>
                                                <div
                                                    v-else
                                                    class="svg-icons-display-wrapper"
                                                    style="height: 225px;display: flex;width: 100%;justify-content: center"
                                                    >
                                                    <div v-if="attachment.state && attachment.state == 'OUTDATED'" class="outdated-text">
                                                        OUTDATED
                                                    </div>
                                                <div class="svg-icons-display" style="width:90px !important;height:90px !important" v-html="getSvgIconsOfMediaTypes(attachment)"></div>
                                                <div class="storage-type-icons-wrapper">
                                                    <svg v-if="isActionEnable('Download')" @click.stop.prevent="handleDownloadAction(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#a3adad" class="bi bi-download" viewBox="0 0 16 16">
                                                        <title>Download</title>
                                                        <path fill-rule="evenodd" d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                                        <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                                    </svg>
                                                    <svg v-if="attachment.state && attachment.state == 'OUTDATED' && getVersionInfoDisplayCheck" v-on:click.stop.prevent="openManageVersions(attachment)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-files" viewBox="0 0 16 16">
                                                        <title>View versions</title>
                                                        <path d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z"/>
                                                    </svg>
                                                </div>
                                                </div>
                                                <div v-if="'slug_name' in attachment" style="display:flex;" :title="attachment.slug_name">
                                                    <div class="svg-icons-display" v-html="getSvgIconsOfMediaTypes(attachment)">
                                                    </div>
                                                    <div style=" margin-top: 7px; text-align: start;white-space: nowrap;width: 100%;overflow: hidden;text-overflow: ellipsis;font-size:12px;margin:9px;margin-inline-start:0px">
                                                        {{attachment.slug_name}}
                                                    </div>
                                                </div> 
                                                <div v-else style="display:flex;" :title="attachment.file_name">
                                                    <div class="svg-icons-display" v-html="getSvgIconsOfMediaTypes(attachment)">                              
                                                    </div>
                                                    <div style=" margin-top: 7px; text-align: start;white-space: nowrap;width: 100%;overflow: hidden;text-overflow: ellipsis;font-size:12px;margin:9px;margin-inline-start:0px">
                                                        {{attachment.file_name}}
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                </div> 
                            </div>
                        </template>
                        <chatTextArea :replyContext="false"
                         :usersList="getUsersListToMention(reviewInfo)"
                         :closeMentions="closeMentions"
                         :uploadPathObj="uploadPathObj"
                         @messageText="addReplyCommentToReview" :customStylesTextarea="{'increaseHeightOnClick':true, 'placeholderName':'Reply...', 'disabledActions':['attach-tasks']}"></chatTextArea>
                    </div>
                </div> 
            </div> 
        </div>
        <ImagePreviewDialog class="hide-element-util-mount" v-cloak  :selectedFile="assetDetailsToShowPip" @closeMiniPlayer="closeMinimisedPlayer" v-if="showOtherFilesPreviewDialog"></ImagePreviewDialog>
        <ManageVersionsDialog v-if="openVersionDisplayDialog" @close="closeVersionDisplayDialog" :fileInfo="selectedFileToViewVersions" :disableUpload='true'></ManageVersionsDialog>
        <PictureInPicture ref="pic-pic" @hook:mounted="picPicZindex(9999999, 'pic-pic')" calss="hide-picture" v-cloak v-if="openPip" :selectedFile="assetDetailsToShowPip"  @closeMiniPlayer="closeMinimisedPlayer"></PictureInPicture>
    </div>
</template>

<script>
import Utils from "../../components.utils.js";
import chatTextArea from '../core/ChatTextarea.vue';
import Constants from "../../components.constants.js";
import ImagePreviewDialog from "./ImagePreviewDialog.vue";
import {mapActions, mapGetters} from "vuex";
//import ManageVersionsDialog from "../ManageVersions/ManageVersionsDialog.vue";
import PictureInPicture from "../files/MiniPlayer.vue";

export default {
    props:["commentData","repliedCommentslist", "enableEditParentTextIDProp","selectedCommentRowID","fileInfoPreview","reviewInfo","isRepliedRequired","enableReplyEditDeleteActionRequired","uploadPathObj"],
    data(){
        return{
            hideReplyThread:null,
            assetDetailsToShowPip:{},
            openPip:false,
            showOtherFilesPreviewDialog:false,
            selectedReplyInfo:null,
            editParentCommentID:null,
            closeMentions: false,
            parentInfo:null,
            selectedFileToViewVersions:null,
            openVersionDisplayDialog:false,
            isRepliedActionRequired: true,
            isReplyEditDeleteActionRequired: true,
        }
    },
    //ManageVersionsDialog  dynamically loading from plugin
    components:{chatTextArea,PictureInPicture,ImagePreviewDialog},
    methods: {
        isMarkerOrAnnotation(commentData){
           if(commentData && commentData.markers && commentData.markers.frame_thumbnail_uri != undefined && commentData.markers.frame_thumbnail_uri.length){
                  return true;
           }
           if(commentData && Object.prototype.hasOwnProperty.call(commentData,'comment_type') 
               && commentData.comment_type == 'annotate' && Object.prototype.hasOwnProperty.call(commentData,'annotaion_thumbnail_url')){
                return true;
            }
            return false;
        },
        isAnnotationCommentType(commentData){
            if(commentData && Object.prototype.hasOwnProperty.call(commentData,'comment_type') 
               && commentData.comment_type == 'annotate' && Object.prototype.hasOwnProperty.call(commentData,'annotaion_thumbnail_url')){
                return true;
            }
            return false;
        },
        //----------------------Open or Edit reply----------------------
        openRepliesOrAddReply(isRepliesAvailable){
                this.$emit("showRepliesOfComment",this.commentData,isRepliesAvailable);
        },
        editParentComment(){
            this.editParentCommentID = this.commentData._id;
        },
        //--------------------------------------------------------------
        getDuration(time){
            return Utils.getDurationInSeconds(time);
        },
        getMarkoutDuration(markoutObj){
           if(markoutObj && markoutObj.mark_out)
              return ' - ' + Utils.getDurationInSeconds(markoutObj.mark_out);
           return '';
        },
        style(name){
            let style = {
                'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
            }
            return style
        },
        getReplyCount(replyCountValue){
            let replyCount = 0;
            if(replyCountValue == 1){
                replyCount = replyCountValue +" Reply";
            }else if(replyCountValue > 1){
                replyCount = replyCountValue +" Replies";
            }
            return replyCount;
        },
        updateCommentStatus(){
            if(this.commentData.status == "Open"){
                this.commentData.status = "Close"
            }else{
                this.commentData.status = "Open"
            }
            this.$emit("commentStatusUpdate", this.commentData);
        },

        formatedDate(date){
            return Utils.getDateTimeFormat(date);
        },
        addReplyCommentToReview(text,attachments){
            console.log("texttext",text,attachments)
            this.$emit("messageText",text,attachments)
        },
        selectedReplyInfoText(replyInfo){
            this.selectedReplyInfo = replyInfo;
            this.enableEditParentTextIDProp = null;
        },
        getThumbnail(fileInfo = {}){
            console.log("fileInfo fileInfo:",fileInfo);
            if(fileInfo && Object.prototype.hasOwnProperty.call(fileInfo,'comment_type') 
               && fileInfo.comment_type == 'annotate' && Object.prototype.hasOwnProperty.call(fileInfo,'annotaion_thumbnail_url')){
                  return  fileInfo.annotaion_thumbnail_url;
            }
            return Utils.getThumbnailPathfromFileInfo(fileInfo);
        },
        closeOpenedMentionsDopdown(){
            this.closeMentions = false;
            this.closeMentions = true;
            console.log("this.closeMentionsthis.closeMentions",this.closeMentions)
        },
        openPictureInPicture(fileInfo,event){
            if(event){
                event.stopPropagation();
                event.preventDefault();
            }
            this.$emit("openPictureInPicture",fileInfo)
            // if(fileInfo.markers){
            //         let markin = fileInfo.markers.start / 1000;
            //         let markout = fileInfo.markers.end / 1000;
            //         if(markin && isNaN(Number(markin))) markin = Utils.hhmmssToMs(markin);
            //         if(markout && isNaN(Number(markout))) markout = Utils.hhmmssToMs(markout);
            //         this.assetDetailsToShowPip = fileInfo;
            //         Object.assign(this.assetDetailsToShowPip,{file_name:fileInfo.file_info[0].file_name,mime_type:'image/png'});
            //         if(this.isFullscreenPreviewAllowed()){
            //             this.openPip = false;
            //             this.showOtherFilesPreviewDialog = true;
            //             return;
            //         }else{
            //             this.openPip = true;
            //             this.showOtherFilesPreviewDialog = false;
            //         }
            //         try{
            //             setTimeout(() => {
            //                 this.$refs["miniPlayerReForSubclip"].playSubClipPreview({"markin":markin,"markout":markout});
            //             },900);
            //         }catch(e){console.log(e)}
            // }else{
            //     this.assetDetailsToShowPip = fileInfo;
            //     if(this.isFullscreenPreviewAllowed()){
            //         this.openPip = false;
            //         this.showOtherFilesPreviewDialog = true;
            //         return;
            //     }else{
            //         this.openPip = true;
            //         this.showOtherFilesPreviewDialog = false;
            //     }
            // }
        },
        handleDownloadAction(fileInfo){
            let payload = {};
            if(fileInfo.parent_path){
                payload.bin_id = Utils.getBinIdFromPath(fileInfo.parent_path);
            }else if(fileInfo.parent_id_path){
                payload.bin_id = Utils.getBinIdFromPath(fileInfo.parent_id_path);
            }
            payload.element_type = "file";
            payload.job_name = "Download";
            payload.file_name = fileInfo.file_name;
            payload.path = fileInfo.path;
            let fileName = fileInfo.file_name;
            this.initiateDownloadJob(payload).then((data) => {
                let jobIdFromResponse = data.job_id;
                let payload = { job_id: "job_id=" + jobIdFromResponse };
                let downnloadUrl = `${Constants.downloadUrl}?${payload.job_id}`;
                const link = document.createElement("a");
                link.href = downnloadUrl;
                link.download = fileName;
                link.click(); 
                if (Utils.isAcceptedStatusCode(data.statusCode) == 200) {
                    console.log("Share asset Download initiated");
                } else {
                    this.$toast.error(data.message);
                }
            });
        },
        isFullscreenPreviewAllowed(){
            let allowedFullScreenPreview = ['image',...Constants.supportedDocumentPreviewList,...Constants.supported3dModelPreviewList];
            return allowedFullScreenPreview.indexOf(Utils.getFileMediaType(this.assetDetailsToShowPip)) > -1
        },
        picPicZindex(zvalue, ref){
            this.$refs[ref].$el.style.cssText += `z-index:${zvalue} !important`
        },
        openPipOfSelectedFile(fileInfo){
            this.openPictureInPicture(fileInfo)
        },
        closeMinimisedPlayer(){
            this.openPip = false;
            this.showOtherFilesPreviewDialog = false;
        },
        isActionEnable(priv){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege,priv)
        },
        replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        getSvgIconsOfMediaTypes(path, type) {
            return Utils.determineSvgIconForType(path, type);
        },
        deleteSelectedMessage(commentsDetails){
            this.$emit("deleteRepliedComment",commentsDetails)
        },
        editCommentTextOfParent(text){
            this.$emit("editCommentText",text,this.commentData);
            this.editParentCommentID = null;
        },
        emitEdittedCommentTextOfReply(text){
            this.$emit("editCommentText",text,this.selectedReplyInfo);
            this.selectedReplyInfo = null;
            this.enableEditParentTextIDProp = false;
        },
        unsetEditFields(){
            this.$emit("cancelEditField");
            this.editParentCommentID = null;
        },
        urlifyFromUtils(text){
            if(text != undefined && text != null && text != ""){
            var mentionsRegex = /\B@[a-z0-9_-]+/gi;
            let that = this;
            text = text.replace(mentionsRegex,function(mention){
                let temp = mention.substr(1);
                if(temp == that.getLoggedInUser){
                    return '<span style="border-radius: 15px;padding: 3px 7px;background: #007373c9;color: #eee;">' + mention + '</span>';
                }else{
                    return '<span style="border-radius: 15px;background: transparent;color: #2cbdbd;">' + mention + '</span>';
                }
            })
            var urlRegex = /(https?:\/\/[^\s]+)/g;
            return text.replace(urlRegex, function(url) {
                return '<a href="' + url + '" target="_blank" style="overflow-wrap: anywhere;color:#1d9bd1">' + url + '</a>';
            });
            }  
        },
        replaceWithUserIcon(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        getUsersListToMention(reviewInfoData){
            if(this.commentData && this.isAnnotationCommentType(this.commentData)){
                return;
            }
            let tempReviewInfoData = JSON.parse(JSON.stringify(reviewInfoData));
            if(this.reviewInfo && Object.keys(this.reviewInfo).length>0){
                let createrData = {"_id":this.reviewInfo.created_by_id,"username":this.reviewInfo.created_by_name,"profile_image":this.reviewInfo.reporter_profile_image[this.reviewInfo.created_by_id]}
                let findIndex = tempReviewInfoData.assignee_info.findIndex(e => e._id == createrData._id)
                if(findIndex == -1){
                    tempReviewInfoData.assignee_info.push(createrData)
                }
                if(tempReviewInfoData.approver_info){
                    tempReviewInfoData.assignee_info = tempReviewInfoData.assignee_info.concat(tempReviewInfoData.approver_info)
                }else{
                    tempReviewInfoData.assignee_info
                }
                return tempReviewInfoData.assignee_info
            }else{
                return [];
            }    
        },
        isEnabled(priv) {
          return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, priv);
        },
        openManageVersions(file){
            this.openVersionDisplayDialog = true;
            this.selectedFileToViewVersions = file;
        },
        closeVersionDisplayDialog(){
            this.openVersionDisplayDialog = false;
            this.selectedFileToViewVersions = null;
        },
        ...mapActions("download", ["initiateDownloadJob", "downloadFile"]),
    },
    watch:{
        enableEditParentTextIDProp(newVal){
            this.editParentCommentID = null;
            if(newVal)this.editParentCommentID = newVal;
            this.hideReplyThread = null;
        },
        reviewInfo(newVal){
            if(newVal){
                this.parentInfo = newVal
            }
        }
    },  
    computed:{
        ...mapGetters("versions",["getVersionInfoDisplayCheck"]),
        ...mapGetters("users",["getLoggedInUser","getLoggedInUserPrivilege","getLoggedInUserId"]),
   },
    created(){
        try{ //load external plugin manage-versions. below code taken from index.js of then media version plugin
           Utils.loadPluginBundles([{id:'manage_version_bundle_js',jsUrl:`${window.location.origin}/damplugins/media_version/web/manage_version_bundle.js`}],'mediaversion-component-loaded').then((event)=>{
                console.log("[Media version][Event]",event);
                if(event && Array.isArray(event) && event.length){
                    if(event[0].components['ManageVersionDialog']){
                    const ev = new Event('register-stores-routes');
                    if(Object.prototype.hasOwnProperty.call(event[0] , 'pluginStore'))
                        ev.pluginStore = event[0].pluginStore;
                        parent.document.body.dispatchEvent(ev);
                        Utils.loadCssBundle({id:'manage_version_bundle_css',cssUrl:`${window.location.origin}/damplugins/media_version/web/manage_version_bundle.css`});
                        this.$options.components['ManageVersionsDialog'] = event[0].components['ManageVersionDialog'];
                    }
                }
            });
        }catch(e){console.log(e)}
        if(this.isRepliedRequired != null || this.isRepliedRequired != undefined){
            this.isRepliedActionRequired = this.isRepliedRequired;
        }
        if(this.enableReplyEditDeleteActionRequired != null || this.enableReplyEditDeleteActionRequired != undefined){
            this.isReplyEditDeleteActionRequired = this.enableReplyEditDeleteActionRequired;
        }
        if(this.selectedCommentRowID == this.commentData._id){
            this.showReplies(this.commentData)
        }
        if(this.enableEditParentTextIDProp){
            this.editParentCommentID = this.enableEditParentTextIDProp;
            this.hideReplyThread = null
        }
        if(this.reviewInfo){
            this.parentInfo = this.reviewInfo
        }
    },
}
</script>


<style scoped lang="scss">
    $active-green-icon-color: #00ff3a;
    $count-bg-color:#e7c20b;
    $count-border-color:#373737;
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $panel-heading-font-size:18px;
    $secondary-border-color: 1px solid #2b2b2b;
    $linkText-color: #1d9bd1;
    $duration-color: #01868c;
    $sub-border-color: #212121;
    $border-left-color-for-replies: #f59d00cf;

    .user-name-or-image{
        height: 30px;
        width: 30px !important;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }

    .user-name{
        margin-inline-end: 4px;
        position: relative;
        bottom: 7px;
        text-align:center !important;
    }

    .comments-thread-wrapper{
        display:flex;
        justify-content: space-between;
        padding: 10px;
        border: 1px solid $sub-border-color;
        border-radius: 5px;
        .comment-info-wrapper{
            display:flex;
            justify-content: space-between;
            width:93%;
            .comment-info-sub-wrapper{
                display:flex;
                flex-direction: column;
                width: 100%;
                .commentBy-name{
                    display: flex;
                    justify-content: space-between;
                }
                .comment-text{
                    user-select: text !important;
                    cursor: text;
                    margin: 4px 2px 4px 0px;
                }
                .commentedOn-datetime{
                    color:$secondary-text-color;
                    margin-inline-start: 5px;
                    font-size:12px;
                }
                .replies-info-wrapper{
                    display:flex;
                    align-items: center;
                    .repliedBy-images{
                        display:flex;
                    }
                    .repliesBy-count{
                        color: $linkText-color;
                    }
                    .repliesBy-count:hover{
                        text-decoration: underline;
                    }
                }
                .replied-comments-thread-wrapper{
                    border-inline-start: 3px solid $border-left-color-for-replies;
                    border-radius: 0px;
                    display: flex;
                    flex-direction: column;
                    padding: 0px 10px;
                }
                .replied-comment-info-wrapper{
                    flex-direction: column;
                    margin-inline-start: 3px;
                }
            }
        }
        .commentedOn-duration{
            height: 20px;
            padding: 10px 10px;
            display: flex;
            align-items: center;
            font-size: 12px;
            border-radius: 3px;
            background: $duration-color;
            width: fit-content;
            margin: 5px 0px;
        }
    }

    .attachments-in-message{
        list-style-type: none;
        display: inline-flex;
        flex-wrap: wrap;
        padding: 0;
        margin-top: 0;
        width: 100%;
        justify-content: start;
        overflow: auto;
        position: relative;
        div{
            margin: 5px;
        }
    }

    .thumbnail-view:hover, .svg-icons-display-wrapper:hover{
        .storage-type-icons-wrapper{
            visibility: visible;
        }
    }

    .thumbnail-view, .svg-icons-display-wrapper{
        position:relative;
    }

    .storage-type-bottom-icons-wrapper{
        color: #999;
        background: #1a1a1ab3;
        min-width: 30px;
        width: auto;
        inset-inline-end: -1px;
        bottom: -1px;
        border-bottom-right-radius: 4px;
        border-top-left-radius: 4px;
        position: absolute;
        display: flex;
        justify-content: center;
    }

    .svg-icons-display-wrapper{
        align-items: center;
        border: $border-color;
        border-radius: 7px;
        .svg-icons-display{
            height: 70px !important;
            width: 70px !important;
            margin: 12% auto;
        }
    }

.svg-icons-display {
  height: 20px;
  width: 20px;
  position: relative;
  opacity: 0.8;
  inset-inline-end: 5px;
}

.storage-type-icons-wrapper{
    visibility: hidden;
    color: #999;
    background: #000000c9;
    min-width: 30px;
    width: auto;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 4px;
    position: absolute;
    top: 6px;
    inset-inline-end: 6px;
    line-height: 1;
    margin-inline-start: 8px;
    border: unset;
    --saf-0: rgba(var(--sk_foreground_low,29,28,29),0.13);
    box-shadow: 0 0 0 1px var(--saf-0),0 1px 3px 0 rgba(0,0,0,.08);
    display: flex;
    padding: 5px;
    border-radius: 0.375em;
    justify-content: space-evenly;
    width: auto;
    svg{
        margin: 0px 4px;
    }
    a#bd-versions:hover {
        background: transparent;
        border-radius: 0px;
    }
}

.actions-on-comment{
    position: absolute;
    inset-inline-end: 0px;
    border: $secondary-border-color;
    width: auto;
    height: 35px;
    border-radius: 4px;
    padding: 0px 5px;
    background: $bg-color-on-hover;
    svg{
        margin:2px;
        background: #d1d2d31a;
        padding: 4px;
        height: 28px;
        width: 28px;
        border-radius: 4px;
        margin-inline-end: 5px;
        color: #c0c0c0;
    }
    svg:hover{
        background: #fdfeff54;
    }
}
.actions-on-comment{
    visibility: hidden;
}

.hover-to-show-actions:hover{
    background: $bg-color-on-hover;
    .actions-on-comment{
        visibility: visible;
    }
}

.common-input-field{
    max-height: unset !important;
}

.actions-on-parent-comment{
    position: absolute;
    inset-inline-end: 0px;
    border: $secondary-border-color;
    width: auto;
    height: 35px;
    border-radius: 4px;
    padding: 0px 5px;
    background: $bg-color-on-hover;
    svg{
        margin:2px;
        background: #d1d2d31a;
        padding: 4px;
        height: 28px;
        width: 28px;
        border-radius: 4px;
        margin-inline-end: 5px;
        color: #c0c0c0;
    }
    svg:hover{
        background: #fdfeff54;
    }
}
.actions-on-parent-comment{
    visibility: hidden;
}

.comment-parent-row-wrapper:hover{
    background: $bg-color-on-hover;
    .actions-on-parent-comment{
        visibility: visible;
    }
}

.comment-parent-row-wrapper{
    margin:3px;
    position: relative;
}

.version-tags{
    border: 1px solid #4a4a4a;
    border-radius: 15px;
    padding: 3px 10px;
    display: flex;
    align-items: center;
    margin-inline-start: 7px;
    color: #9c9c9c;
    font-size: 12px;
    justify-content: center;
    margin-top: -4px;
  }

  .outdated-text{
    position: absolute;
    top: 0px;
    font-weight: 500;
    background: #cf7f06;
    z-index: 0;
    width: 79px;
    text-align: center!important;
    height: 26px;
    padding-top: 3px;
    inset-inline-start:0px;
    font-size: 13px;
    border-radius: 5px;
}

</style>